


































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AuthEmptyLayout from '@/layouts/AuthEmptyLayout.vue'
import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
import { ButtonTheme } from '@/utils/ButtonAttr'
import TranslationModule from '@/utils/TranslationModule'
import ModalOnboardingContactPartner from '@/components/Modal/ModalOnboardingContactPartner.vue'
import { UserRole } from '@/types/UserRole.type'
import { Spa2Route } from '@/ExternalRoutes'

const User = namespace('user')

@Component({
    components: { ModalOnboardingContactPartner, BaseButton, AuthEmptyLayout },
})
export default class UpdateAccountLayout extends Vue {
    TranslationModule: typeof TranslationModule = TranslationModule
    ButtonTheme: typeof ButtonTheme = ButtonTheme
    Spa2Route = Spa2Route

    @User.Getter hasRole!: (role: UserRole) => boolean
    @User.Getter isPartner!: boolean

    get CommunityUrlRefresh() {
        return process.env.VUE_APP_SPA2_BASE_URL + '/?refresh=1'
    }
}
